import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Deep clone a plain JSON-serializable value. Faster and type-safe compared
 * to the JSON.parse(JSON.stringify(x)) idiom.
 */
export function deepClone<T>(value: T): T {
  return structuredClone(value);
}

export function getFileExtension(filename: string): string {
  const parts = filename.split(".");
  return parts.length > 1 ? (parts.pop() ?? "") : "";
}
